import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { RestQuery } from '../../rest/utilities/rest-query'
import { BaseEngineer } from './base-engineer'

@Mapped(
  {
    engineer: { format: BaseEngineer.create },
    is_in: { property: 'in' },
    is_vehicle_checked: { property: 'vehicleChecks' },
    payroll_notes: { property: 'payrollNotes' },
    clocked_at: { property: 'date', type: 'date' },
  },
  ['numericID']
)
export class ClockIn extends Mappable {
  id!: number
  numericID!: number
  engineer!: BaseEngineer;
  in!: boolean
  vehicleChecks!: boolean
  issues!: string
  payrollNotes!: string
  date!: Date

  static create<Data>(attrs: Data) {
    return new ClockIn().map(attrs)
  }
}

interface Filters {
  engineer?: number
  range?: {
    start: string
    end: string
  }
  issues?: boolean
}
type Ordering = 'clocked_at' | '-clocked_at'
type Includes = 'engineer'

export class ClockInQuery extends RestQuery<Filters, Ordering, Includes> {}
